<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="shuaixn()">刷新</el-button>
      <el-button type="danger">逾期单数{{ yqcount }}-- 逾期总金额{{ yqprice }}</el-button>
      <el-button type="primary">已还单数{{ yhcount }}-- 已还总金额{{ yhprice }}</el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <!-- <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>


    <!--表格-->
    <el-table :data="tableData.data" style="width: 100%">
      <el-table-column label="ID" width="50">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>

      <el-table-column label="姓名">
        <template slot-scope="scope">
         {{ scope.row.username }}
          <!-- <div>昵称： {{ scope.row.user.nickName ? scope.row.user.nickName : "null" }}</div>
          <div>身份证号：{{ scope.row.usernum }}</div>
          <div>手机号：{{ scope.row.user.mobile }}</div>
          <div>订单号：{{ scope.row.order_no }}</div> -->
        </template>
      </el-table-column>

      <el-table-column label="订单号" width="150">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="图片" width="60">
        <template slot-scope="scope" v-if="!scope.row.is_top_row">
          <div style="display:flex;justify-content:center;align-items:center;">
            <img style="width: 65px;height: 65px;" :src="scope.row.product[0].image.file_path">
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="订单信息" width="200">
        <template slot-scope="scope">
          <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
            <div class="info">
              <div class="name gray3 product-name">
                <div>{{ item.product_name.slice(0,18) }}</div>
                <!-- <div style="color: #999999;">{{ item.product_attr }}</div>
                <div>{{ scope.row.lease_type == 1 ? "租完即送" : "租完买断" }}</div> -->
              </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="下单时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>

      <el-table-column label="租赁开始时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.newcreate_time }}
        </template>
      </el-table-column>

      <el-table-column label="总租期">
        <template slot-scope="scope">
          {{ scope.row.lease_time }}
        </template>
      </el-table-column>

      <el-table-column label="总租金"  width="120">
        <template slot-scope="scope">
          ￥{{ scope.row.zongzujin }}
        </template>
      </el-table-column>

      <el-table-column label="逾期期数">
        <template slot-scope="scope">
          {{ scope.row.yuqiqishu }}
        </template>
      </el-table-column>

      <el-table-column label="逾期总金额">
        <template slot-scope="scope">
          ￥ {{ scope.row.yuqijine }}
        </template>
      </el-table-column>


      <el-table-column label="已还期数">
        <template slot-scope="scope">
          {{ scope.row.qishu1 }}
        </template>
      </el-table-column>

      <el-table-column label="已还金额">
        <template slot-scope="scope">
          ￥ {{ scope.row.yuqijine1 }}
        </template>
      </el-table-column>

      <el-table-column label="预交金额">
        <template slot-scope="scope">
          ￥ {{ scope.row.yushou }}
        </template>
      </el-table-column>

      <el-table-column prop="zuhoutip" label="备注" width="350">
        <template slot-scope="scope" v-if="!scope.row.is_top_row">
          <div>{{ scope.row.zuhoutip }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="flzt" label="法律状态">
        <template slot-scope="scope" v-if="!scope.row.is_top_row">
          <div>{{ scope.row.flzt }}</div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="250">
        <template slot-scope="scope">
          <div style="display:flex;">
            <el-button @click="addClick(scope.row)" type="info" size="small">订单详情</el-button>
            <el-button @click="gohuankuan(scope.row)" type="primary" size="small">还款详情</el-button>
            <el-button @click="beizhu(scope.row)" type="success" size="small">备注</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog title="还款详情" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="bill_id" label="ID"></el-table-column>
        <el-table-column property="current_period" label="期数"></el-table-column>
        <el-table-column property="price" label="应还款金额"></el-table-column>
        <el-table-column label="还款时间">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.repayment_date | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column label="是否已经还">
          <template slot-scope="scope">
            <template v-if="scope.row.is_pay_status == 0">
              <span style="margin-left: 10px;color:#FF0000;">未还</span>
            </template>
            <template v-else-if="scope.row.is_pay_status == 1">
              <span style="margin-left: 10px;color: #18BC9C;">已还</span>
            </template>
            <template v-else-if="scope.row.is_pay_status == 2">
              <span style="margin-left: 10px;">逾期</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 备注 -->
    <el-dialog title="备注" :visible.sync="dialogVisiblebeiz" width="30%">
      <div style="margin-top: 20px;display: flex;align-items: center;">
        <div style="width: 14%;">备注:</div>
        <el-input v-model="bzfrom.inputbeizhu" placeholder="请输入备注信息" style="margin-top:10px;"></el-input>
      </div>

      <div style="margin-top: 20px;display: flex;align-items: center;">
        <div style="margin-right:15px;">法律状态:</div>
        <el-select v-model="bzfrom.inputfl" placeholder="请选择">
          <el-option v-for="item in flztlist" :key="item.val" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblebeiz = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>

  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import FengkongApi from "@/api/fengkong.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  data() {
    return {
      show: false,
      bzfrom: {
        inputbeizhu: "", //备注信息
        inputfl: "", //法律状态
        order: ""
      },
      flztlist: [{
        name: '正常',
        val: 1
      },
      {
        name: '失联',
        val: 2
      },
      {
        name: '律师函已发',
        val: 3
      },
      {
        name: '起诉',
        val: 4
      },
      {
        name: '约定还款时间',
        val: 5
      },
      {
        name: '部分已还',
        val: 6
      },
      {
        name: '关机',
        val: 7
      },
      {
        name: '通话中未接拒绝',
        val: 8
      }
      ],
      dialogVisiblebeiz: false,
      yqprice: "",
      yhprice: "",
      yqcount: "",
      yhcount: "",
      gridData: "",
      dialogTableVisible: false,
      //预交金额
      yushou: "",
      //已还金额
      qian1: "",
      //期数
      qishu: "",
      //逾期总金额
      total_price: "",
      //逾期期数
      yuqi: "",
      //租赁开始时间
      create_time1: "",
      yuqijine: "",
      // 时间格式化
      time: "",
      // 十位数 时间戳
      timeTemp: "",
      // 十三位数 时间戳
      timesTemp: "",
      zujin: "",
      shop_url: "",
      htdata: "",
      // 签署id
      folwid: "",
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        order_no: "",
        style_id: "",
        create_time: "",
        total_price: "",
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: "",
      create_time1: "",
      total_price: "",

      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0,
      },
      isLogistics: false,
      logisticsData: {},
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    beizhu(row) {
      this.bzfrom.inputfl= row.flzt;
      this.bzfrom.inputbeizhu = row.zuhoutip;
      this.dialogVisiblebeiz = true;
      this.bzfrom.order = row.order_id;
    },
    // 备注提交
    submit() {
      console.log("点击了提交");
      console.log(this.bzfrom);
      let Params = {
        order_id: this.bzfrom.order,
        flzt: this.bzfrom.inputfl,
        zuhoutip: this.bzfrom.inputbeizhu
      };
      OrderApi.zhflzt(Params, true)
        .then(data => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.getData();
          this.dialogVisiblebeiz = false;
        })
        .catch(error => { });
    },
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    gohuankuan(row) {
      this.dialogTableVisible = true;
      console.log("还款", row);
      let Params = {
        order_id: row.order_id,
      };
      OrderApi.zuqi(Params, true)
        .then((res) => {
          console.log("成功", res);
          this.gridData = res.data.billList;
          console.log("asda", this.gridData);
        })
        .catch((error) => { });
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      OrderApi.orderlist1(Params, true)
        .then((res) => {
          self.yqprice = res.data.yqprice.toFixed(2);
          self.yhprice = res.data.yhprice.toFixed(2);
          self.yhcount = res.data.yhcount;
          self.yqcount = res.data.yqcount;
          console.log("resres", res);

          self.tableData = res.data.list;

          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            console.log(item);
            let qishu = 0;
            let qishu1 = 0;
            let yuqijine = 0;
            let yuqijine1 = 0;
            let zongqian = 0;
            for (let j = 0; j < item.order_bill.length; j++) {
              let data = item.order_bill[j];
              let qian = data.price;
              if (data.is_pay_status == 2) {
                yuqijine = Number(yuqijine) + Number(qian);
              }
              if (data.is_pay_status == 1) {
                yuqijine1 = Number(yuqijine1) + Number(qian);
              }
              let yuqi = data.is_pay_status;
              if (yuqi == 2) {
                qishu += 1;
              }
              if (yuqi == 1) {
                qishu1 += 1;
              }
              zongqian = data.price * item.lease_time;
              // console.log(item);
            }
            item.yuqijine = yuqijine;
            item.yuqijine1 = yuqijine1;
            item.qishu = qishu;
            item.qishu1 = qishu1;
            item.yushou = item.yushou;
            item.zongzujin = zongqian.toFixed(2);


            var TheEnglishTime = new Date(item.create_time);
            this.time = timeFormat(TheEnglishTime); // 时间格式化  y-m-d h:m:s
            this.timeTemp = parseInt(TheEnglishTime.getTime() / 1000); // 秒
            this.timesTemp = TheEnglishTime.getTime(); // 毫秒
            let create_time1 = this.timeTemp + 259200;
            let date = new Date(create_time1 * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? "0" + d : d; //天补0
            let h = date.getHours();
            h = h < 10 ? "0" + h : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s; //秒补0
            var timedata = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
            item.newcreate_time = timedata;

            self.tableData.data[i] = item;

            // console.log("self.tableData", self.tableData);

          }
          self.totalDataNumber = res.data.list.total;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch((error) => { });
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({ path: '/order/order/Detail', query: { order_id: params } });
      window.open(routeData.href, '_blank');
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      };
      // self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then((res) => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          console.log(self.logisticsData);
          self.openLogistics();
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
  },
  filters: {
    // 过滤器
    formatDate(create_time) {
      let date = new Date((create_time) * 1000);  //+ 259200
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    },
    formatDate2(create_time) {
      let date = new Date((create_time) * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    },
  },
};
</script>
<style lang="scss">
.el-table td,.el-table th {
    padding: 0;
}
.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/received/zhindex.vue